import { FavouritesSizePickerFlags } from 'features/favourites/types'

export const getSizePickerFlags = (): FavouritesSizePickerFlags => ({
  isCloseIconInContainer: process.env.IS_DROPDOWN_CLOSE_ICON_IN_CONTAINER_ENABLED === 'enabled',
  shouldAddActiveSizePickerOverlay: process.env.IS_OVERLAY_VISIBLE_ENABLED === 'enabled',
  showFullContainer: process.env.IS_SHOW_FULL_CONTAINER_ENABLED === 'enabled',
  isAddToBagOOSVisible: process.env.IS_ADD_TO_BAG_OOS_BUTTON_ENABLED === 'enabled',
  isOOSTransparentBtnBackgroundEnabled:
    process.env.IS_OOS_TRANSPARENT_BACKGROUND_ENABLED === 'enabled',
  isBorderBottomVariantEnabled:
    process.env.IS_BORDER_BOTTOM_VARIANT_SIZE_PICKER_ENABLED === 'enabled',
  isBorderTopVariantEnabled: process.env.IS_BORDER_TOP_VARIANT_SIZE_PICKER_ENABLED === 'enabled',
  isPickerListHeadingEnabled: process.env.IS_PICKER_LIST_HEADING_ENABLED === 'enabled',
  isDropDownSizeGuideEnabled: process.env.IS_DROPDOWN_SIZE_GUIDE_ENABLED === 'enabled',
  isDropDownIconForOOSSizePickerEnabled:
    process.env.IS_DROPDOWN_ICON_FOR_OOS_SIZE_PICKER_ENABLED === 'enabled',
  isDropDownItemsCenterAligned: process.env.IS_DROPDOWN_ITEM_CENTER_ALIGNED_ENABLED === 'enabled',
  isDropDownOOSItemDisabled: process.env.IS_DROPDOWN_OOS_ITEMS_DISABLED === 'enabled',
  isAddToBagButtonIconVisible: process.env.IS_CART_ADD_TO_BAG_BUTTON_ICON_ENABLED === 'enabled',
  isCloseIconInHeading:
    process.env.IS_SIZEPICKER_DROPDOWN_CLOSE_ICON_IN_HEADING_ENABLED === 'enabled',
  dropdownPosition:
    process.env.IS_SIZEPICKER_DROPDOWN_POSITION_BELOW_ENABLED === 'enabled' ? 'below' : 'default',
  isCustomCloseInHeadingIcon:
    process.env.IS_SIZEPICKER_DROPDOWN_CLOSE_ICON_IN_HEADING_ENABLED === 'enabled',
})
